import { useNavigate } from "react-router";
import { ROUTES } from "~components/routeDefinitions.ts";
import { useCurrentTenant } from "~contexts/CurrentTenantContext/CurrentTenantContext.tsx";
import { useCurrentEmployeeRunningTimeTracking } from "../api/timeTracking.ts";
import { useTimeTrackingTitle } from "../shared/useTimeTrackingTitle/useTimeTrackingTitle.ts";
import { RunningTimeTrackingBannerView } from "./RunningTimeTrackingBannerView.tsx";

export function RunningTimeTrackingBanner() {
  const navigate = useNavigate();
  const { number: tenantNumber } = useCurrentTenant();

  const { data: runningTimeTracking, isLoading: isLoadingRunningTimeTracking } =
    useCurrentEmployeeRunningTimeTracking();

  const { isLoading, title } = useTimeTrackingTitle(runningTimeTracking);

  const handleClick = () => {
    if (!runningTimeTracking?.id) {
      return;
    }
    navigate(
      ROUTES.timeTracking.link({
        tenantNumber,
        timeTrackingId: runningTimeTracking.id,
      }),
    );
  };

  if (!runningTimeTracking || isLoading || isLoadingRunningTimeTracking) {
    return null;
  }

  const titleStr = `${title.primary} - ${title.secondary}`;

  return (
    // biome-ignore lint/a11y/noStaticElementInteractions: TODO
    <div onClick={handleClick} onKeyUp={handleClick}>
      <RunningTimeTrackingBannerView title={titleStr} />
    </div>
  );
}
